export const LOGO_URL =
  "https://storage.helloreaddy.io/project_files/8ede1629-48ad-4015-89eb-b95dfff38e03/153867dd-f7f2-4b2d-84f5-773d14938326_compressed_Logo_Iokus.webp";

export const MAPS_LINK = "https://maps.app.goo.gl/RPN3gYTJUYm318Ha6";
export const DIRECTIONS_LINK =
  "https://www.google.com/maps/dir/?api=1&destination=6.2330883,-75.1618101";
export const WAZE_LINK = "https://waze.com/ul?ll=6.2330883,-75.1618101&navigate=yes";

export const MAP_EMBED_URL =
  "https://maps.google.com/maps?q=Tienda+de+Juegos+y+Juguetes+de+Madera+iokus+Guatap%C3%A9&hl=es&z=17&output=embed";

export const PHONE_DISPLAY = "+57 310 441 9856";
export const PHONE_TEL = "tel:+573104419856";

export const ADDRESS_LINE_1 = "Museo del Zócalo — Local 408";
export const ADDRESS_LINE_2 = "Calle 29 #30-11, Guatapé, Antioquia";
export const HOURS_TEXT = "Todos los días, 10:30 a. m. – 6:30 p. m.";

export const SHOP_URL = "https://iokus.co";
export const CATALOG_URL = "https://iokus.co/collections/todos";
export const INSTAGRAM_URL = "https://www.instagram.com/iokus.co/";
export const FACEBOOK_URL = "https://www.facebook.com/iokus.co";

export const NAV_ITEMS = [
  { href: "#inicio", label: "Inicio" },
  { href: "#como-llegar", label: "El local" },
  { href: "#encontrar", label: "Qué encontrarás" },
  { href: "#familia", label: "Juegos de mesa" },
  { href: "#peques", label: "Juguetes" },
  { href: "#resenas", label: "Reseñas" },
  { href: "#por-que-iokus", label: "Por qué Iokus" },
  { href: "#preguntas", label: "Preguntas" },
];